/* eslint-disable no-nested-ternary */
import { SimpleArrowIcon } from 'assets/icons'
import { moneyFormat, toTitleCase } from 'utils'
import TransferRefusedIcon from 'assets/icons/TransferRefusedIcon'
import { movementIcon } from 'utils/movementFunction'
import { getMovementListProperties } from 'utils/bank'
import { humanReadable } from 'utils/date-fns'
import { AcData } from 'types/api/activities'
import Badge from 'components/Badge'

interface MovementsItemProps {
  act: AcData
  handleClick: () => void
  isTransfer?: boolean
}

const MovementsItem = ({
  act,
  handleClick,
  isTransfer = false
}: MovementsItemProps) => {
  const badTransfer = act.result === 'Rechazado'
  const pendingStatus = act.result === 'Pendiente'
  const date = humanReadable(act.created_at)
  const parsedAct = getMovementListProperties(act)
  const title = toTitleCase(parsedAct.secondText) || parsedAct.secondText

  return (
    <button
      type='button'
      onClick={handleClick}
      className='cursor-pointer relative h-14 px-2 font-medium text-xs leading-140 text-color-black w-full items-center justify-start flex min-h-[56px]'
    >
      {pendingStatus ? (
        <Badge
          variant='YELLOW'
          className='absolute -top-[10px] right-4 px-4 !py-0'
        >
          <p>Pendiente</p>
        </Badge>
      ) : null}
      <p className='shrink-0 mr-2'>
        {badTransfer ? (
          <TransferRefusedIcon />
        ) : (
          movementIcon(parsedAct.firstText)
        )}
      </p>
      <div className='flex-grow max-w-[calc(100%_-_8rem)] w-full justify-start items-start flex flex-col text-left'>
        <p
          className={`font-bold ${badTransfer ? 'text-red-900' : 'text-black'}`}
        >
          {badTransfer && 'Transferencia rechazada'}
          {!badTransfer && !isTransfer && parsedAct.firstText}{' '}
          {!badTransfer && isTransfer && title}{' '}
        </p>
        <div className='flex-row flex items-start w-full justify-start text-gray-900 opacity-50 shrink-0'>
          <span
            className={`whitespace-nowrap max-w-[calc(100%_-_4rem)] overflow-hidden text-ellipsis pr-1 ${
              title.length >= 11 &&
              'sm:text-inherit sm:whitespace-normal sm:overflow-auto sm:w-auto'
            }`}
          >
            {isTransfer ? act.result : title}
          </span>{' '}
          -<span className='pl-1'>{date || ''}</span>
        </div>
      </div>
      <div className='flex flex-grow items-center shrink-0 justify-end'>
        <span
          className={`font-semibold ${
            parsedAct.balance ? 'text-green-900' : 'text-red-900'
          } ${badTransfer && 'text-[#616161]'}`}
        >
          {badTransfer ? '' : parsedAct.balance ? '+' : '-'}{' '}
          {moneyFormat(parsedAct.amount)?.replace(' ', '')}
        </span>
        <SimpleArrowIcon className='mr-2 ml-4 shrink-0' />
      </div>
    </button>
  )
}

export default MovementsItem
